import "../styles/layout.scss";

import {
  Application,
  type ApplicationComponentData,
  type ApplicationComponentDatasetData,
  Component,
  type ComponentParameters,
} from "@lisergia/core";

import { configure } from "mobx";

import MenuButtonVideo from "./datasets/MenuButtonVideo";
import Navigation from "./datasets/Navigation";
import RiveAnnouncement from "./datasets/RiveAnnouncement";

/**
 * Only bootstrap navigation if the full page-2026 app hasn't already loaded.
 * On Page 2026 template pages, index.ts handles everything including
 * Lenis scroll, routes, and page lifecycle.
 *
 * On old pages we only init the navigation and menu button components —
 * no routes, no page, no Lenis — so native scroll is preserved.
 */
if (
  !(window as typeof window & { __PAGE_2026_LOADED__?: boolean })
    .__PAGE_2026_LOADED__
) {
  Application.IS_LINKS_ENABLED = false;

  configure({
    enforceActions: "never",
  });

  const components: Array<ApplicationComponentData> = [
    {
      component: Navigation as new (params?: ComponentParameters) => Component,
    },
  ];

  const datasets: Array<ApplicationComponentDatasetData> = [
    {
      component: MenuButtonVideo as new (params?: ComponentParameters) => Component,
      selector: "[data-menu-button]",
    },
    {
      component: RiveAnnouncement as new (params?: ComponentParameters) => Component,
      selector: "[data-rive-announcement]",
    },
  ];

  datasets.forEach(({ component: DatasetComponent, selector }) => {
    document.querySelectorAll(selector).forEach((element) => {
      const instance = new DatasetComponent({
        element: element as HTMLElement,
      });

      Application.addComponent(
        instance as InstanceType<typeof Component>,
      );
    });
  });

  Application.initComponents(components);
}
